import { styled } from "@mui/material";
import EncasedImage from "./EncasedImage";
import { TypographyWithEllipsis } from "./TypographyWithEllipsis";
import SkeletonLoader from "./SkeletonLoader";
import { User } from "../../dataAccess/api/user";
import { getNameInitials } from "../../helpers/formatter";

interface Props {
  textColor?: string;
  user?: User;
  loading?: boolean;
}

const SkeletonContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
}));

const StyledSkeletonLoader = styled(SkeletonLoader)(() => ({
  margin: 0,
}));

const UserName = styled(TypographyWithEllipsis)<{ color?: string }>(
  ({ theme, color }) => ({
    marginLeft: "0.8rem",
    color: color || theme.palette.text.bannerPaper,
    fontWeight: "bold",
  }),
);

const avatarSize = 40;
const avatarSizeLoading = avatarSize * 1.7;
function ProfileInfo({ loading, user, textColor }: Props) {
  if (!user) {
    return null;
  }

  if (loading) {
    return (
      <SkeletonContainer>
        <StyledSkeletonLoader
          variant="circular"
          height={avatarSizeLoading}
          width={avatarSizeLoading}
        />
        <StyledSkeletonLoader variant="text" height="1rem" width="10rem" />
      </SkeletonContainer>
    );
  }

  return (
    <>
      <EncasedImage
        alt={`${user.firstName} ${user.lastName}`}
        height={avatarSize}
        width={avatarSize}
        src={user.pictureUrl}
        variant="circle"
        initials={getNameInitials(user.firstName, user.lastName)}
      />
      <UserName clamp={2} color={textColor}>
        {user.firstName} {user.lastName}
      </UserName>
    </>
  );
}

export default ProfileInfo;
